import { createContext } from "react";
import { PastRuns } from "../types/run";

export interface IPastRunsContext {
  pastRuns: PastRuns;
  setPastRuns: (value: PastRuns) => void;
  /** Re-reads the "pastRuns" value from local storage into state. */
  refreshPastRuns: () => void;
}

export const PastRunsContext = createContext<IPastRunsContext | null>(null);
